import type {PermissionsRecordType} from '../permissions';

export const documentPermissions = {
  signDocument: {
    actionId: 'SIGN',
    resourceId: 'DOCUMENT',
    scopes: [],
  },
} satisfies PermissionsRecordType;
